<template>
  <b-modal
    title="New Project"
    hide-footer
    v-model="showModal"
  >
    <EditProjectForm
      ref="edit-project-form"
      :project="project"
      :mode="mode"
      @submit="submit"
      @reset="cancel">
    </EditProjectForm>
  </b-modal>
</template>
<script>
  import EditProjectForm from "@/form-components/EditProjectForm.vue";

  export default {
    props: {
      project: { type: Object, default: null },
      mode: { type: String, default: 'Edit' }
    },
    components: {
      EditProjectForm
    },
    data() {
      return {
        showModal: false
      }
    },
    methods: {
      show() {
        this.showModal = true;
      },
      hide() {
        this.showModal = false;
      },
      submit(projectId) {
        this.$emit('submit', projectId);
      },
      cancel() {
        this.reset();
        this.hide();
      },
      reset() {
        this.$refs['edit-project-form'].resetForm();
      }
    }
  }
</script>